const peaceDays = [
  ['Be still', 'Begin with five quiet minutes and release what you cannot control.', 'Psalm 46:10'],
  ['Receive peace', 'Name one worry and ask Jesus to meet you there.', 'John 14:27'],
  ['Trust the next step', 'Pray for wisdom without demanding the whole map.', 'Proverbs 3:5-6'],
  ['Lay down anxiety', 'Turn each concern into a specific prayer.', 'Philippians 4:6-7'],
  ['Rest in God’s care', 'Remember where you have already been carried.', 'Psalm 23:1-3'],
  ['Practice gratitude', 'Thank God for three quiet gifts from this week.', '1 Thessalonians 5:16-18'],
  ['Carry peace outward', 'Pray for someone who needs steadiness and hope.', 'Romans 15:13']
];

const peopleDays = [
  ['Your household', 'Pray for peace, patience, and kindness at home.', 'Colossians 3:12-14'],
  ['A close friend', 'Pray for the need they may not know how to voice.', 'Proverbs 17:17'],
  ['Someone who is hurting', 'Ask for comfort, healing, and faithful support.', 'Psalm 34:18'],
  ['Your church', 'Pray for unity, wisdom, and humble service.', 'Ephesians 4:2-3'],
  ['A caregiver', 'Pray for renewed strength and moments of rest.', 'Isaiah 40:31'],
  ['A young person', 'Pray for guidance, belonging, and wise influences.', '1 Timothy 4:12'],
  ['A leader', 'Pray for integrity, wisdom, and concern for others.', '1 Timothy 2:1-2'],
  ['A neighbor', 'Pray for an opportunity to show practical love.', 'Mark 12:31'],
  ['Someone facing a decision', 'Pray for clarity, courage, and patience.', 'James 1:5'],
  ['Someone grieving', 'Pray for comfort and gentle companionship.', 'Matthew 5:4'],
  ['Someone far away', 'Pray across the distance and reach out if you can.', 'Philippians 1:3-4'],
  ['Someone difficult to love', 'Ask God to soften your heart and guide your response.', 'Matthew 5:44'],
  ['Your community', 'Pray for safety, justice, and neighbors who care.', 'Jeremiah 29:7'],
  ['The people God brings to mind', 'Pause and pray for each name without rushing.', 'Philippians 4:6']
];

const psalmThemes = [
  ['Begin with delight', 'Psalm 1'], ['God is near', 'Psalm 16'], ['The Lord is my shepherd', 'Psalm 23'],
  ['Wait with courage', 'Psalm 27'], ['Bring God your fear', 'Psalm 34'], ['Be still', 'Psalm 46'],
  ['Create in me a clean heart', 'Psalm 51'], ['Rest in God alone', 'Psalm 62'], ['Let the nations rejoice', 'Psalm 67'],
  ['God is our help', 'Psalm 70'], ['Tell the next generation', 'Psalm 78'], ['A prayer for restoration', 'Psalm 80'],
  ['Teach us to number our days', 'Psalm 90'], ['Sing a new song', 'Psalm 96'], ['Give thanks', 'Psalm 100'],
  ['Remember God’s benefits', 'Psalm 103'], ['A lamp for the path', 'Psalm 119:105'], ['Help comes from the Lord', 'Psalm 121'],
  ['Those who sow in tears', 'Psalm 126'], ['Search me, O God', 'Psalm 139'], ['A prayer for protection', 'Psalm 140'],
  ['Let my prayer rise', 'Psalm 141'], ['When spirit grows faint', 'Psalm 142'], ['Teach me to do your will', 'Psalm 143'],
  ['Great is the Lord', 'Psalm 145'], ['God heals the brokenhearted', 'Psalm 147'], ['Praise with all creation', 'Psalm 148'],
  ['Praise among the people', 'Psalm 149'], ['Let everything praise', 'Psalm 150'], ['Look back with gratitude', 'Psalm 136']
];

export const prayerPlans = [
  {
    id: 'peace-7',
    title: 'Seven Days of Peace',
    description: 'A gentle week for releasing worry and receiving God’s steady presence.',
    duration: 7,
    tone: 'sage',
    days: peaceDays.map(([title, description, scripture]) => ({ title, description, scripture }))
  },
  {
    id: 'people-14',
    title: 'Fourteen Days for Others',
    description: 'A simple rhythm for remembering the people and communities around you.',
    duration: 14,
    tone: 'berry',
    days: peopleDays.map(([title, description, scripture]) => ({ title, description, scripture }))
  },
  {
    id: 'psalms-30',
    title: 'Thirty Days in the Psalms',
    description: 'A month of prayer prompts shaped by the language and themes of the Psalms.',
    duration: 30,
    tone: 'sand',
    days: psalmThemes.map(([title, scripture]) => ({
      title,
      description: `Read ${scripture} slowly. Turn one phrase into your own prayer.`,
      scripture
    }))
  }
];

export const getPrayerPlan = (planId) => prayerPlans.find((plan) => plan.id === planId) || null;

export default prayerPlans;
